export default __webpack_public_path__ + "static/media/3-smiling-face-with-smiling-eyes_1f60a.fefdbb48.png";